const WorkingHoursEnum = [
    { value: '-20', label: 'Menos de 20hs' },
    { value: '20-35', label: 'Entre 20hs y 35hs' },
    { value: '35+', label: 'Mas de 35hs' },
  ];

  export default WorkingHoursEnum;